<div class="component-container power-connection-container">
  <form [formGroup]="powerConnectionFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-font-size">
    <app-review-section
      #powerConnectionSection
      [title]="'technician-data.power-connection-title' | translate"
      [tooltip]="'tooltips.technician-form.power-connection' | translate"
      [showTooltip]="infoBubblesData?.showPowerSupplyInfo"
      [sectionId]="sectionIdentifier.TechnicalData_BaseData_Power"
      [applicationId]="applicationId"
      [isDetailsView]="isDetailsView">
      <div class="form-background form-section">
        <div class="ui-g-12 form-rows">
          <div class="ui-g-6 field-rows" *ngIf="powerConnectionFG.get('totalOutput')">
            <label
              for="power-connection-total-output"
              class="ui-g-5 field-label text-right-align"
              [class.required]="isFieldRequired('totalOutput')">
              {{
                (showConnectedLoadLabel ? 'technician-data.form-fields.connected-load' : 'technician-data.form-fields.total-output')
                  | translate
              }}
            </label>
            <input
              [appNumber]="true"
              class="ui-input pInputText small-width"
              formControlName="totalOutput"
              id="power-connection-total-output"
              maxlength="5"
              pInputText
              size="30"
              [readonly]="!powerConnectionSection.isDataEditable" />
            <span class="field-unit-label">{{ unitLabels.power }}</span>
          </div>
          <div class="field-rows" *ngIf="powerConnectionFG.get('requiredFusePower')">
            <label class="field-label text-right-align required" for="power-connection-fuse-power">
              {{ 'technician-data.form-fields.swkn-required-fuse-power' | translate }}
            </label>
            <p-dropdown
              [options]="requiredFusePowerTypes"
              [readonly]="!powerConnectionSection.isDataEditable"
              formControlName="requiredFusePower"
              id="power-connection-fuse-power"
              placeholder="-Select-">
              <ng-template let-item pTemplate="selectedItem">
                <span class="drop-item-label">
                  {{ 'lookup.' + requiredFusePowerTypeKey + '.options.' + item['value'] + '.name' | translate }}
                </span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <span class="drop-item-label">
                    {{ 'lookup.' + requiredFusePowerTypeKey + '.options.' + option['value'] + '.name' | translate }}
                  </span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div
            *ngIf="showInfoTextRequiredFusePowerLarger200A"
            class="max-fuse-power-info-text"
            [innerHTML]="'technical-data.required-fuse-power-larger-200a' | translate"></div>
          <div class="ui-g-6 field-rows padding-left-1" *ngIf="showStandardPowerWarning || showInfoForCommodities">
            <span [innerHTML]="'technician-data.standard-power-warning' | translate"></span>
          </div>
        </div>
        <div *ngIf="powerConnectionFG.get('craneAvailable')" class="ui-g-12 form-rows">
          <div class="ui-g-6 field-rows">
            <label class="ui-g-5 field-label text-right-align required mr-3">
              {{ 'technician-data.form-fields.crane-available' | translate }}
            </label>
            <span class="ui-g-3 available-radio-buttons">
              <p-radioButton
                formControlName="craneAvailable"
                label="{{ 'yes-button-label' | translate }}"
                name="craneAvailable"
                [value]="true"></p-radioButton>
              <p-radioButton
                formControlName="craneAvailable"
                label="{{ 'no-button-label' | translate }}"
                name="craneAvailable"
                [value]="false"></p-radioButton>
            </span>
          </div>
        </div>

        <ng-container *ngIf="showPowerConnectionExtendendOptionsForNewMains">
          <div class="ui-g-12 form-rows field-rows">
            <div class="ui-g-12 field-rows radio-button-group">
              <label class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows required mr-3">
                {{ 'technician-data.form-fields.house-connection-installation-location' | translate }}
              </label>
              <div *ngFor="let item of installationLocationTypes" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <p-radioButton
                  formControlName="installationLocationType"
                  label="{{ item.label }}"
                  name="installationLocationType"
                  [value]="item.value"
                  [disabled]="!powerConnectionSection.isDataEditable"></p-radioButton>

                <input
                  *ngIf="item.value.toLowerCase() === 'other'"
                  class="ui-input pInputText small-width"
                  formControlName="installationLocationTypeOther"
                  id="installationLocationTypeOther"
                  maxlength="5"
                  pInputText
                  size="30"
                  [readonly]="
                    !powerConnectionSection.isDataEditable || powerConnectionFG.value.installationLocationType?.toLowerCase() !== 'other'
                  " />
              </div>
            </div>
          </div>

          <div class="ui-g-12 form-rows">
            <div class="ui-g-6 field-rows">
              <label class="ui-g-5 field-label required mr-3">
                {{ 'technician-data.form-fields.offer-for-earthworks-on-private-property' | translate }}
              </label>
              <span class="ui-g-3 available-radio-buttons">
                <p-radioButton
                  formControlName="offerEarthworksOnPrivateProperty"
                  label="{{ 'yes-button-label' | translate }}"
                  name="offerEarthworksOnPrivateProperty"
                  [value]="true"
                  [disabled]="!powerConnectionSection.isDataEditable"></p-radioButton>
                <p-radioButton
                  formControlName="offerEarthworksOnPrivateProperty"
                  label="{{ 'no-button-label' | translate }}"
                  name="offerEarthworksOnPrivateProperty"
                  [value]="false"
                  [disabled]="!powerConnectionSection.isDataEditable"></p-radioButton>
              </span>
            </div>
          </div>

          <div class="ui-g-12 form-rows field-rows">
            <div class="ui-g-12 field-rows radio-button-group">
              <label class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows required mr-3">
                {{ 'technician-data.form-fields.planned-type-of-heating' | translate }}
              </label>
              <div *ngFor="let item of powerConnectionHeatingTypes" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <p-radioButton
                  formControlName="powerConnectionHeatingType"
                  label="{{ item.label }}"
                  name="powerConnectionHeatingType"
                  [value]="item.value"
                  [disabled]="!powerConnectionSection.isDataEditable"></p-radioButton>

                <input
                  *ngIf="item.value.toLowerCase() === 'other'"
                  class="ui-input pInputText small-width"
                  formControlName="powerConnectionHeatingTypeOther"
                  id="powerConnectionHeatingTypeOther"
                  maxlength="5"
                  pInputText
                  size="30"
                  [readonly]="
                    !powerConnectionSection.isDataEditable || powerConnectionFG.value.powerConnectionHeatingType?.toLowerCase() !== 'other'
                  " />
              </div>
            </div>
          </div>
        </ng-container>

        <div *ngIf="powerConnectionFG.get('pumpAvailable')" class="ui-g-12 form-rows">
          <div class="ui-g-6 field-rows">
            <label class="ui-g-5 field-label text-right-align required mr-3">
              {{ 'technician-data.form-fields.pump-available' | translate }}
            </label>
            <span class="ui-g-3 available-radio-buttons">
              <p-radioButton
                formControlName="pumpAvailable"
                label="{{ 'yes-button-label' | translate }}"
                name="pumpAvailable"
                [value]="true"></p-radioButton>
              <p-radioButton
                formControlName="pumpAvailable"
                label="{{ 'no-button-label' | translate }}"
                name="pumpAvailable"
                [value]="false"></p-radioButton>
            </span>
          </div>
        </div>

        <div *ngIf="showSpecialConsumers">
          <ng-container *ngFor="let value of specialDeviceCount">
            <app-special-consumers
              (deleteComponent)="removeChildElements($event)"
              [isReadOnly]="!powerConnectionSection.isDataEditable"
              [specialDeviceData]="specialDeviceData[value]"></app-special-consumers>
          </ng-container>
          <div class="ui-g-12 add-button-row" *ngIf="powerConnectionSection.isDataEditable && showAddPowerDeviceButton">
            <div class="empty-container"></div>
            <i (click)="addSpecialDevice()" class="pi pi-plus plus-icon" id="power-connection-add-consumer"></i>
            <label class="ui-g-5 field-label" for="power-connection-add-consumer">
              {{ 'technician-data.form-fields.special-consumers-button' | translate }}
            </label>
          </div>
        </div>
      </div>
    </app-review-section>
    <ng-container *ngIf="showTempConnectionRegistrationForNewMains">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-section-header [title]="'technician-data.form-fields.registration-temp-connection-title' | translate"></app-section-header>
      </div>

      <div class="form-background form-section">
        <div class="ui-g-12 form-rows">
          <div class="ui-g-12 field-rows">
            <p-checkbox
              formControlName="requiredTempConnectionLess30"
              binary="true"
              name="required-temp-connection-less30"
              label="{{ 'technician-data.form-fields.temp-power-connection-less30' | translate }}"></p-checkbox>
          </div>
        </div>
        <div class="ui-g-12 form-rows" *ngIf="powerConnectionFG.get('requiredTempConnectionLess30').value">
          <div class="ui-g-8 field-rows">
            <label for="technician-bdew-id" class="field-label text-right-align required">
              {{ 'technician-data.form-fields.technician-bdew-id' | translate }}
            </label>
            <input
              class="ui-input pInputText small-width mr-3"
              formControlName="technicianBdewId"
              id="technician-bdew-id"
              maxlength="9"
              pInputText
              size="30"
              [readonly]="!powerConnectionSection.isDataEditable || isTechnician" />
            <div *ngIf="!powerConnectionFG.get('isTechnicianRegistered').value && isCustomer">
              {{ 'technician-data.form-fields.technician-not-registered' | translate }}
            </div>
            <div *ngIf="powerConnectionFG.get('isTechnicianRegistered').value && isCustomer">
              <input
                class="ui-input pInputText"
                [(ngModel)]="technicianName"
                [ngModelOptions]="{ standalone: true }"
                id="technician-name"
                pInputText
                size="30"
                readonly="true" />
            </div>
          </div>
          <div class="ui-g-4 field-rows" *ngIf="isCustomer">
            {{ 'technician-data.form-fields.no-bdew-id-message' | translate }}
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="showTempPowerReportConfirmationForNewMains">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-section-header [title]="'technician-data.form-fields.temp-power-connection-report-title' | translate"></app-section-header>
      </div>
      <div class="form-background form-section">
        <div class="ui-g-12 form-rows">
          <div class="ui-g-12 field-rows">
            <p-checkbox
              binary="true"
              formControlName="tempPowerReportConfirmed"
              name="temp-power-connection-confirmation"
              label="{{ 'technician-data.form-fields.temp-power-connection-confirmation' | translate }}"></p-checkbox>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</div>
